export const PERGUNTAS_LIST = 'PERGUNTAS_LIST';
export const PERGUNTAS_LIST_START = 'PERGUNTAS_LIST_START';
export const PERGUNTAS_LIST_SUCCESS = 'PERGUNTAS_LIST_SUCCESS';
export const PERGUNTAS_LIST_ERROR = 'PERGUNTAS_LIST_ERROR';
